import type { TI_KeyValueData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTIKeyValueData: Omit<TI_KeyValueData, 'selectedVariable'> =
  {
    title: 'Default KeyValue Title'
  };
